import { searchDataInt } from "@/type/home";
import { getProductInt } from "@/type/product";
import { getBrochureInt } from "@/type/about";

import service from ".";

// 封面列表
export function getBanner(data:searchDataInt){
    return service({
        url: "web/bannerlist",
        method: "get",
        params: data
    })
}

// 作品列表
export function getProduct(data:getProductInt){
    return service({
        url: "web/productlist",
        method: "get",
        params: data
    })
}

// 展览列表
export function getShow(){
    return service({
        url: "web/showlist",
        method: "get",
    })
}

// 艺术家列表
export function getArtist(){
    return service({
        url: "web/artistlist",
        method: "get",
    })
}

// 创作过程列表
export function getCreative(){
    return service({
        url: "web/creativelist",
        method: "get",
    })
}

// 宣传册列表
export function getBrochure(data:getBrochureInt){
    return service({
        url: "web/brochurelist",
        method: "get",
    })
}
